import React from "react";
import LoginView from "./LoginView";

const LoginModule = () => {
  return <LoginView />;
};

export default LoginModule;
